import { getAuthorizedClients, getTaxReport } from '@/api/tax-report';

const taxReport = {
  namespaced: true,
  state: () => ({
    AuthorixedClients: [],
    GeneratedReport: null,
    Status: '',
  }),
  getters: {
    getAuthorizedClients: (state) => state.AuthorixedClients,
    getGeneratedReport: (state) => state.GeneratedReport,
    getStatus: (state) => state.Status,
  },
  actions: {
    fetchAuthorizedClients({ commit }) {
      return new Promise((resolve, reject) => {
        getAuthorizedClients()
          .then((clients) => {
            commit('SET_AUTHORIZED_CLIENTS', clients);
          })
          .catch(() => {
            console.log('error from fetchAuthorizedClients store');
          });
      });
    },
    getTaxReport({ commit }, payload) {
      commit('SET_STATUS', 'generating');
      return new Promise((resolve, reject) => {
        getTaxReport(payload)
          .then((report) => {
            commit('SET_GENERATED_REPORT', { ...report, email: payload.email });
          })
          .catch(() => {
            console.log('error from getTaxReport store');
          });
      });
    },
    resetGeneratedReport({ commit }) {
      commit('SET_GENERATED_REPORT', null);
    },
  },

  mutations: {
    SET_AUTHORIZED_CLIENTS: (state, clients) => {
      state.AuthorixedClients = clients ? clients : [];
    },
    SET_GENERATED_REPORT: (state, generatedReport) => {
      state.GeneratedReport = generatedReport;
      state.Status = '';
    },
    SET_STATUS: (state, status) => {
      state.Status = status;
    },
  },
};

export default taxReport;
